import { Domain } from 'fs-api-client';
import { createDomain } from '../services/filespace';
import DomainAction, { DomainActionProperties } from './DomainAction';
import { DescriptionWrapperProperties } from './common/DescriptionWrapper';
import { injectDomain } from './hocs/DomainInjector';
import { PageRoutes } from './root/Routes';
import { LogManager } from '../utils/LogManager';
import { EventHandler } from './hocs/EventHandler';

const logManager = new LogManager('EnterDomain');

class EnterDomain extends DomainAction {
    constructor(props: DomainActionProperties) {
        super(props);
    }

    protected onDomainLoaded(domain: Domain) {
        if (domain) {
            this.props.history.push(PageRoutes.Dashboard);
        }
    }

    protected getDescriptions(): DescriptionWrapperProperties {
        return {
            title: 'Create your workspace',
            description: ['🏢 Your workspace name (or domain) uniquely identifies your organization or team.', '🚀 Completing this step will give a start to your trial.']
        };
    }

    protected onDomainSubmit(domainName: string) {
        let domain = new Domain();
        domain.name = domainName;
        createDomain(domain)
            .then(() => {
                this.onDomainCreated();
                this.setState({ isAwaitingRequest: false });
            })
            .catch((error: any) => {
                this.onDomainNotCreated(error);
                this.setState({ isAwaitingRequest: false });
            });
    }

    private onDomainCreated = () => {
        EventHandler.onDomainCreated();
        this.props.history.push(PageRoutes.Dashboard);
    }

    private onDomainNotCreated = (err: any) => {
        logManager.error(err);
        let message = err.response.body.message;
        if (err.response.body.code === 500) {
            message = 'An error occurred.';
        }
        this.setState({
            errorMessage: message
        });
    }
}

export default injectDomain(EnterDomain);



// WEBPACK FOOTER //
// ./src/webportal/components/EnterDomain.tsx